var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['tw-inline-flex tw-items-center tw-rounded-full tw-font-normal tw-whitespace-nowrap', _vm.colorClass, _vm.sizeClass]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }